import { SectionTabsLayout, type SectionTabItem } from "./section-tabs-layout";

const ENTITY_ASSETS_TABS: SectionTabItem[] = [
  {
    // The picker and the loaded entity card: the only tab with a write path
    // to artwork or text, and the one every row's "Load" action lands on.
    //
    // Named "Editor" until the owner pointed out the collision: BTL's Editor
    // is @breakingthelines/editor, the rich text editor embedded in studio and
    // the pages CMS, and there is none of it here. "Entity" is what the tab
    // shows - one entity, its images, its name. The old /editor path still
    // resolves, redirected in router.tsx.
    label: "Entity",
    to: "/entities/assets/entity",
    match: (pathname) => pathname.startsWith("/entities/assets/entity"),
  },
  {
    // Everything that has been changed, text and artwork together. This was two
    // tabs, Corrections and Artwork, until the owner asked why the page needed
    // three: one tab edits an entity and the other lists what has been edited,
    // and a stored image is as much an edit as a renamed club. The old
    // /artwork path redirects here (router.tsx), and the segment stays
    // "overrides" so nothing already bookmarked has to move.
    label: "Corrections",
    to: "/entities/assets/overrides",
    match: (pathname) => pathname.startsWith("/entities/assets/overrides"),
  },
];

/**
 * The Entity assets page's own subtabs, nested one level inside Discovery's
 * section tabs (see discovery-layout.tsx). Same idiom, one level deeper: the
 * page took v2 and v3 as a single stack (picker, overrides list, art list),
 * the owner asked for it split (#85), and then for the two lists to be one.
 * See router.tsx for the routes this switches between.
 */
export function EntityAssetsLayout() {
  return <SectionTabsLayout id="entity-assets" items={ENTITY_ASSETS_TABS} />;
}
